import { all } from "redux-saga/effects";
import commonSaga from "../saga/common";
import authSaga from "../saga/auth";
import movementSaga from "../saga/movement";

export default function* rootSaga() {
    yield all([commonSaga(),authSaga(),movementSaga()]);
}
